import { accountURL } from '../config/SiteConfig';

export function getParams(params = new URLSearchParams(location.search)) {
    return Object.fromEntries(
        params.entries().map(([key, value]) => {
            if (key === 'q') {
                return ['query', value.replace('::', ':relevance:')] as const;
            } else {
                return [key, value] as const;
            }
        }),
    ) as Record<string, string>;
}

export function getIdFromPath(url: Location) {
    return url.pathname.split('/').at(-1);
}

export function getRedirectUrl(fallback = accountURL()) {
    const redirectUrl = new URLSearchParams(window.location.search).get('redirect') ?? fallback;
    if (new URL(document.baseURI).origin === new URL(redirectUrl, document.baseURI).origin) {
        return redirectUrl;
    } else {
        return fallback;
    }
}

export function setUrl(params: string, replaceHistory: boolean) {
    const url = params ? `${location.pathname}?${params}` : location.pathname;

    if (replaceHistory) {
        history.replaceState({ scrollPos: window.scrollY }, '', url);
    } else if (url !== location.search) {
        history.pushState({ scrollPos: window.scrollY }, '', url);
    }
}

export function updateSearchParams(params: URLSearchParams, replaceHistory = false) {
    const str = params.toString();
    const url = str ? `${location.pathname}?${params}` : location.pathname;
    if (replaceHistory) {
        history.replaceState(null, '', url);
    } else if (url !== location.pathname + location.search) {
        history.pushState(null, '', url);
    }
}
